import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/aidyn/server/projects/optovichok/frontend/src/app/shopping-cart/components/ShoppingCartInteractive.tsx");
